// Recovered compiled webpack factory 93709. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { zK: () => r });
  var n = i(40479),
    s = i(45385);
  function r(t, { layout: e, layoutId: i }) {
    return (
      n.f.has(t) || t.startsWith("origin") || ((e || void 0 !== i) && (!!s.H[t] || "opacity" === t))
    );
  }
}
